import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn (...inputs) {
  return twMerge(clsx(inputs));
}

export const isNotEmptyAndDefined = value => {
  return value !== undefined && value !== '';
};
export const isObjectNotEmpty = obj => {
  return Object.keys(obj).every(
    key => obj[key] !== null && obj[key] !== undefined && obj[key] !== ''
  );
};
export const downloadCSVFiles = (csvString, fileName = 'File.csv') => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');

  link.download = fileName;

  link.href = URL.createObjectURL(blob);

  link.click();

  URL.revokeObjectURL(link.href);
};
export const getDateWithTimeString = () => {
  const date = new Date();
  const isoString = date.toISOString();
  const formattedDate = isoString
    .replace('T', '_')
    .replace(/\.\d{3}Z/, '')
    .replaceAll(':', '');
  return formattedDate;
};

export const toTitleCase = str => {
  if (!str) return '';
  return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};
